// extracted by mini-css-extract-plugin
export default {"quickMenu":"QuickNav_quickMenu__+Px9E","menu_list":"QuickNav_menu_list__VySvZ","s_tit":"QuickNav_s_tit__l-4NA"};